import request from '@/utils/request'

export function getmerchlist(data) {
  return request({
    url: 'get/merchs',
    method: 'post',
    params: data
  })
}

export function getmerchpayinfos(data) {
  return request({
    url: 'get/merch/payinfos',
    method: 'post',
    params: data
  })
}

export function getMerchPayInfosDownload(data) {
  return request({
    url: 'get/merch/payinfos/download',
    method: 'post',
    params: data
  })
}

export function configMerchPaymentChanel(data) {
  return request({
    url: 'config/merch/payment/chanel',
    method: 'post',
    params: data
  })
}

export function declineMerchPayInfos(data) {
  return request({
    url: 'decline/merch/payinfos',
    method: 'post',
    params: data
  })
}

export function getMerchPayinfoById(data) {
  return request({
    url: 'get/merch/payinfo/byid',
    method: 'post',
    params: data
  })
}

export function getmerchbyid(data) {
  return request({
    url:'get/merch/info/byid',
    method:'post',
    params: data
  })
}

export function activateUpay(data){
  return request({
    url:'upay/activate/terminal',
    method:'post',
    params: data
  })
}

export function getUpayActivatedInfo(data){
  return request({
    url:'upay/get/activate/info',
    method:'post',
    params: data
  })
}

export function editMerchantInfo(data) {
  return request({
    url: 'edit/merch/info',
    method: 'post',
    params: data
  })
}

export function updateSubmissionStatus(data) {
  return request({
    url: 'update/submission/status',
    method: 'post',
    params: data
  })
}

export function setMerchantActive(data) {
  return request({
    url: 'set/merchant/active',
    method: 'post',
    params: data
  })
}

// T01: 商户详情（只读）
export function getMerchantDetail(data) {
  return request({
    url: 'get/merch/detail',
    method: 'post',
    params: data
  })
}

